<template>
    <div v-if="showLoader" class="intro-loader">
        <div class="intro-loader-block">
            <img
                src="/app/themes/tanglin/dist/images/logo-full.svg"
                alt=""
                class="intro-loader__logo"
            >
        </div>
    </div>
</template>

<script>
    export default {
        name: 'intro',
        data() {
            return {
                showLoader: false,
            };
        },
        mounted() {
            if (!window.localStorage.getItem('introShown')) {
                this.showLoader = true;
                window.localStorage.setItem('introShown', true);
            }
        },
    };
</script>

<style lang="scss">
    .intro-loader {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5000;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100vh;
        background: #000;
        animation: slideOut 0.5s ease-in-out;
        animation-fill-mode: both;
        animation-delay: 3s;

        &__logo {
            animation: scale 1s ease;
            animation-fill-mode: both;
            animation-delay: 1s;
        }

        &-block {
            position: relative;
        }
    }

    @keyframes scale {
        0% {
            opacity: 0;
            transform: scale(0.4);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }

    @keyframes slideOut {
        0% {
            opacity: 1;
            transform: translateY(0);
        }
        70% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translateY(-100%);
        }
    }
</style>
